export enum SubscriptionPhase {
  TrialNoCC = "trial_no_cc",
  TrialCC = "trial_with_cc",
  Paid = "paid",
  PaidNoCC = "paid_no_cc",
  ExpiredTrial = "expired_trial",
  ExpiredPaid = "expired_paid",
}
